import Layout from '@/layout';
var teamRouter = {
  path: '/teamBonus',
  component: Layout,
  redirect: '/teamBonus/teamSetting',
  name: 'TeamBonus',
  meta: {
    title: '团队分红',
    icon: 'clipboard'
  },
  children: [{
    path: 'teamSetting',
    component: function component() {
      return import('@/views/teamBonus/setting/index');
    },
    name: 'teamSetting',
    meta: {
      title: '团队分红设置',
      icon: ''
    }
  }, {
    path: 'teamLevel',
    component: function component() {
      return import('@/views/teamBonus/level/index');
    },
    name: 'teamLevel',
    meta: {
      title: '队长等级',
      icon: ''
    }
  }, {
    path: 'product',
    component: function component() {
      return import('@/views/teamBonus/product/index');
    },
    name: 'teamBonusProduct',
    meta: {
      title: '分红商品',
      icon: ''
    }
  }, {
    path: 'product/setting',
    component: function component() {
      return import('@/views/teamBonus/product/form');
    },
    name: 'teamBonusProductSetting',
    meta: {
      title: '设置分红',
      icon: '',
      hidden: true,
      activeMenu: '/teamBonus/product'
    }
  }, {
    path: 'level/add',
    component: function component() {
      return import('@/views/teamBonus/level/form');
    },
    name: 'teamBonusLevelAdd',
    meta: {
      title: '新增队长等级',
      icon: '',
      hidden: true,
      activeMenu: '/teamBonus/teamLevel'
    }
  }, {
    path: 'level/edit',
    component: function component() {
      return import('@/views/teamBonus/level/form');
    },
    name: 'teamBonusLevelEdit',
    meta: {
      title: '编辑队长等级',
      icon: '',
      hidden: true,
      activeMenu: '/teamBonus/teamLevel'
    }
  }, {
    path: 'audit',
    component: function component() {
      return import('@/views/teamBonus/audit/index');
    },
    name: 'teamBonusAudit',
    meta: {
      title: '待审核',
      icon: ''
    }
  }, {
    path: 'leader',
    component: function component() {
      return import('@/views/teamBonus/leader/index');
    },
    name: 'teamBonusLeader',
    meta: {
      title: '队长列表',
      icon: ''
    }
  }, {
    path: 'order',
    component: function component() {
      return import('@/views/teamBonus/order/index');
    },
    name: 'teamBonusOrder',
    meta: {
      title: '分红订单',
      icon: ''
    }
  }, {
    path: 'closing',
    component: function component() {
      return import('@/views/teamBonus/closing/index');
    },
    name: 'teamBonusClosing',
    meta: {
      title: '提现管理',
      icon: ''
    }
  }]
};
export default teamRouter;